import {
    SetAudienceAction,
    SetGoalsAction,
    SetMainMessageAction,
} from './basic-data';

import {
    CloseNoteDialogAction,
    ColorChangedAction,
    CreateNoteAction,
    ShowCreateNoteDialogAction,
    ShowUpdateNoteDialogAction,
    TextAreaChangedAction,
    UpdateNoteAction,
} from './note-dialog';

import {
    DeleteNoteAction,
    NoteDraggingAction,
    MoveNotesAction,
    StartNoteDraggingAction,
    StopNoteDraggingAction,
} from './notes';

import {
    SetPresentationAction,
    SetupStoryboardAction,
    SetProcessStepAction,
    SetTemplateIdAction,
    SetTextFieldAction,
} from './presentation';

import {
    CreateShapeAction,
    CreateSlideAction,
    UpdateSlideNotesAction,
    DeleteSlideAction,
    SlideDraggingAction,
    MoveSlidesAction,
    StartSlideDraggingAction,
    StopSlideDraggingAction,
    StartShapeSketchingAction,
    ShapeSketchingAction,
    StopShapeSketchingAction,
    DeleteShapeAction,
    StartShapeDraggingAction,
    StopShapeDraggingAction,
    ShapeDraggingAction,
    MoveShapeAction,
    StartSelectorDraggingAction,
    SelectorDraggingAction,
    StopSelectorDraggingAction,
    ResizeShapeAction,
    UpdateTextShapeAction,
    SelectShapeAction,
} from './slides';

import {
    CloseSlideNotesDialogAction,
    ShowSlideNotesDialogAction,
    SlideNotesDialogTextChangedAction,
} from './slide_notes-dialog';

import {
    CloseTextShapeDialogAction,
    ShowTextShapeDialogAction,
    TextShapeDialogTextChangedAction,
} from './text-shape-dialog';

import {
    CloseTimeDialogAction,
    ShowTimeDialogAction,
    TimeDialogTextChangedAction,
} from './time-dialog';

import {
    ReportErrorAction,
    HideGenericDialogAction,
    HideHelpAction,
    SetPaneSizeAction,
    SetLocaleAction,
    SetScrollAction,
    SetSketchModeAction,
    SetZoomLevelAction,
    StartPanningAction,
    PanningAction,
    StopPanningAction,
    ShowGenericDialogAction,
    ShowHelpAction,
    ShowHelpContentAction,
    StartHelpPanelDraggingAction,
    HelpPanelDraggingAction,
    StopHelpPanelDraggingAction,
} from './ui-state';

import {
    NoOpAction,
    RedoAction,
    Undoable,
    UndoAction,
} from "./undo";


export type Action =
    ReportErrorAction
    | SetProcessStepAction
    | SetLocaleAction

    | SetGoalsAction
    | SetMainMessageAction
    | SetAudienceAction

    | CloseNoteDialogAction
    | ColorChangedAction
    | CreateNoteAction
    | ShowCreateNoteDialogAction
    | ShowUpdateNoteDialogAction
    | TextAreaChangedAction
    | UpdateNoteAction

    | StartNoteDraggingAction
    | NoteDraggingAction
    | StopNoteDraggingAction
    | MoveNotesAction
    | DeleteNoteAction

    | SetPresentationAction
    | SetupStoryboardAction
    | SetTemplateIdAction
    | SetTextFieldAction

    | CreateShapeAction
    | CreateSlideAction
    | UpdateSlideNotesAction
    | StartSlideDraggingAction
    | SlideDraggingAction
    | StopSlideDraggingAction
    | MoveSlidesAction
    | DeleteSlideAction
    | StartShapeSketchingAction
    | ShapeSketchingAction
    | StopShapeSketchingAction
    | DeleteShapeAction
    | StartShapeDraggingAction
    | ShapeDraggingAction
    | StopShapeDraggingAction
    | MoveShapeAction
    | StartSelectorDraggingAction
    | SelectorDraggingAction
    | StopSelectorDraggingAction
    | ResizeShapeAction
    | UpdateTextShapeAction
    | SelectShapeAction

    | CloseSlideNotesDialogAction
    | ShowSlideNotesDialogAction
    | SlideNotesDialogTextChangedAction

    | CloseTextShapeDialogAction
    | ShowTextShapeDialogAction
    | TextShapeDialogTextChangedAction

    | CloseTimeDialogAction
    | ShowTimeDialogAction
    | TimeDialogTextChangedAction

    | HideGenericDialogAction
    | HideHelpAction
    | SetPaneSizeAction
    | SetScrollAction
    | SetSketchModeAction
    | SetZoomLevelAction
    | StartPanningAction
    | PanningAction
    | StopPanningAction
    | ShowGenericDialogAction
    | ShowHelpAction
    | ShowHelpContentAction
    | StartHelpPanelDraggingAction
    | HelpPanelDraggingAction
    | StopHelpPanelDraggingAction

    | NoOpAction
    | RedoAction
    | UndoAction
    ;

export type UndoableAction = Action & Undoable;


export { MoveNotesAction, MoveSlidesAction };


export {
    setAudience,
    setGoals,
    setMainMessage,
} from './basic-data';

export {
    showUpdateNoteDialog,
    showCreateNoteDialog,
    cancelNoteDialog,
    submitDialog,
    textareaChanged,
    colorChanged,
} from './note-dialog';

export {
    startNoteDragging,
    startNoteDraggingOnStoryboard,
    noteDragging,
    noteDraggingOnStoryboard,
    stopNoteDragging,
    stopNoteDraggingOnStoryboard,
    deleteNote,
} from './notes';

export {
    setPresentation,
    setProcessStep,
    setTemplate,
    setTextField,
} from './presentation';

export {
    createSlide,
    startShapeDragging,
    shapeDragging,
    stopShapeDragging,
    startSelectorDragging,
    selectorDragging,
    stopSelectorDragging,
    startSlideDragging,
    startShapeSketching,
    slideDragging,
    stopSlideDragging,
    deleteSlide,
    shapeSketching,
    stopShapeSketching,
    updateTextShape,
    selectShape,
    deleteShape,
} from './slides';

export {
    closeSlideNotesDialog,
    showSlideNotesDialog,
    submitSlideNotesDialog,
    slideNotesDialogTextChanged,
} from './slide_notes-dialog'

export {
    closeTextShapeDialog,
    showTextShapeDialog,
    submitTextShapeDialog,
    textShapeDialogTextChanged,
} from './text-shape-dialog'

export {
    closeTimeDialog,
    showTimeDialog,
    submitTimeDialog,
    timeDialogTextChanged,
} from './time-dialog';

export {
    reportError,
    hideGenericDialog,
    hideHelp,
    setPaneSize,
    setLocale,
    setScroll,
    setSketchMode,
    setZoomLevel,
    startPanning,
    panning,
    stopPanning,
    showGenericDialog,
    showHelp,
    showHelpContent,
    zoomInSlide,
    startHelpPanelDragging,
    helpPanelDragging,
    stopHelpPanelDragging,
} from './ui-state';

export {
    noEffect,
    noop,
    redo,
    undo,
    Undoable,
} from './undo';


// WEBPACK FOOTER //
// ./src/actions/index.ts